import React, { useState, useEffect, useRef } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { buildWaUrl } from '../utils/whatsapp';

// Shared bulk/single WhatsApp modal (extracted from the TDS/GST pattern).
// targets: [{ name, whatsapp }]
export default function WhatsAppModal({ targets, defaultMsg, onClose }) {
  const isBulk = targets.length > 1;
  const [msg, setMsg] = useState(defaultMsg || '');
  const textRef = useRef();
  useEffect(() => { textRef.current?.focus(); }, []);
  const withNumber = targets.filter(t => t.whatsapp);
  const sendAll = () => {
    targets.forEach((t, i) => {
      if (!t.whatsapp) return;
      const url = buildWaUrl(t.whatsapp, msg);
      if (url) setTimeout(() => window.open(url, '_blank'), i * 400);
    });
    onClose();
  };
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6" onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-2 mb-4">
          <MessageCircle size={20} className="text-green-600" />
          <h3 className="font-semibold text-gray-900">
            {isBulk ? `WhatsApp — ${withNumber.length} of ${targets.length} clients` : `WhatsApp — ${targets[0]?.name}`}
          </h3>
          <button onClick={onClose} className="ml-auto text-gray-400 hover:text-gray-600"><X size={18} /></button>
        </div>
        {isBulk && (
          <div className="mb-3 max-h-24 overflow-y-auto border border-gray-100 rounded-lg divide-y">
            {targets.map((t, i) => (
              <div key={i} className={`px-3 py-1.5 text-xs flex items-center gap-2 ${t.whatsapp ? '' : 'opacity-40'}`}>
                <span className="font-medium text-gray-700 flex-1">{t.name}</span>
                <span className="text-gray-400 font-mono">{t.whatsapp || 'No number'}</span>
              </div>
            ))}
          </div>
        )}
        {!isBulk && targets[0]?.whatsapp && <p className="text-xs text-gray-500 mb-3">+91 {targets[0].whatsapp}</p>}
        <label className="block text-xs font-medium text-gray-700 mb-1">Message</label>
        <textarea ref={textRef} value={msg} onChange={e => setMsg(e.target.value)} rows={7}
          className="input-field text-sm w-full resize-y leading-relaxed mb-4" />
        <div className="flex gap-3">
          <button onClick={sendAll} disabled={withNumber.length === 0}
            className="flex-1 py-2 rounded-lg font-medium text-sm bg-green-600 hover:bg-green-700 text-white disabled:opacity-40 flex items-center justify-center gap-2">
            <MessageCircle size={14} />
            {isBulk ? `Send to ${withNumber.length} client${withNumber.length !== 1 ? 's' : ''}` : 'Send via WhatsApp'}
          </button>
          <button onClick={onClose} className="flex-1 py-2 rounded-lg font-medium text-sm border border-gray-200 text-gray-600 hover:bg-gray-50">Cancel</button>
        </div>
      </div>
    </div>
  );
}
